import { createContext, type ReactNode, useRef } from 'react'
import type { StoreApi } from 'zustand'

import { createDocumentStore, type DocumentStore } from '../stores'

export const DocumentContext = createContext<{
  documentStore: StoreApi<DocumentStore>
} | null>(null)

interface DocumentProviderProps {
  children: ReactNode
}

export const DocumentProvider = ({ children }: DocumentProviderProps) => {
  const documentStoreRef = useRef<StoreApi<DocumentStore>>(
    createDocumentStore(),
  )
  return (
    <DocumentContext.Provider
      value={{
        documentStore: documentStoreRef.current,
      }}
    >
      {children}
    </DocumentContext.Provider>
  )
}
